import React, { FC, useState } from 'react';
import { ReportErrorModal } from './Components/ReportErrorModal';
import { StreamLineIcon } from '../../../../SvgIcon/StreamLineIcon';
import { InsuranceCommonProps } from '../../../../../Partials/InsuranceCommon/InsuranceCommonProps.csharp';
import { InsuranceLabelsContext, useInsuranceLabels } from '../../../Utils/Context/labelsContext';

export const ReportErrorButton: FC<InsuranceCommonProps> = ({isAuthenticated, insuranceLabels}) => {
  const [isModalOpened, setIsModalOpened] = useState<boolean>(false);

  return (
    <>
      {isAuthenticated && (
        <InsuranceLabelsContext labels={insuranceLabels}>
          <button
            type="button"
            aria-haspopup
            aria-expanded={isModalOpened}
            onClick={() => setIsModalOpened(true)}
            className="reportErrorButton"
          >
            <div className="reportErrorButton__content">
              <StreamLineIcon iconName="s-mail-bold" />
              <span>{insuranceLabels.buttons.reportErrorFloatingButtonLabel}</span>
            </div>
          </button>
          {isModalOpened && (
            <ReportErrorModal
              onClose={() => setIsModalOpened(false)}
            />
          )}
        </ InsuranceLabelsContext>
      )}

    </>
  )
};
